<template>
  <v-app>
    <AdSmp />
    <v-banner
      v-if="checkedItems.length!=0"
      color="primary"
    >
      <template v-slot:actions>
        <v-btn
          class="px-3 py-5 mr-2"
          color="secondary"
          elevation="0"
          small
          tile
          @click="multiFolderSelectDialog=true"
        >
          フォルダ移動
        </v-btn>
        <v-btn
          class="px-3 py-5 mr-2"
          color="secondary"
          elevation="0"
          small
          tile
          @click="removeItems()"
        >
          削除
        </v-btn>
        <v-btn
          class="px-3 py-5 mr-4"
          color="secondary"
          elevation="0"
          small
          tile
          @click="checkedItems=[]"
        >
          全て選択解除
        </v-btn>
      </template>
    </v-banner>
    <div
      v-if="checkedItems.length!=0"
      style="height: 4px;width: 100%; background-color: #F08F00"
    />
    <div
      class="flex-container pa-0 ma-0"
    >
      <v-container
        class=" mx-2 mx-sm-5 pa-0 mt-3"
      >
        <v-breadcrumbs
          v-if="links && links.length!=0"
          :items="links"
        />
        <v-row
          class="pb-4 mx-sm-2 mx-0"
          dense
        >
          <v-col
            cols="12"
          >
            <div
              class="d-flex mb-2  align-center"
              style="font-size: 12px;"
            >
              <ListIcon
                :style="`color: ${accentColor};width:6px;height:7px`"
                class="mr-1 mb-1"
              />
              {{ currentNovel.name }} {{ currentNovelSiteTypeString }}
            </div>
            <v-layout
              :style="`height: 60px;background-color: ${backgroundColor}`"
              align-center
              class="ma-0 pa-0"
              d-flex
              justify-start
            >
              <div
                :style="`width:5px; height:100%;background-color:${accentColor}`"
                class="mr-4"
              />
              <div
                :class="folderInItems.parentFolder ? 'sm-hide' : ''"
                style="font-weight: bold;font-size: 18px;"
              >
                本文一覧
              </div>
              <v-spacer />
              <v-btn
                class="px-3 py-5 mr-2"
                color="secondary"
                elevation="0"
                small
                tile
                @click="openSearch()"
              >
                <v-icon>mdi-file-find</v-icon>
              </v-btn>

              <v-btn
                v-if="folderInItems.parentFolder"
                :to="folderInItems.parentFolder === -1 ?
                  {name:'NovelIndex', params:{novelid:encodeHash(novelId)}} :
                  {name:'NovelIndexInFolder', params:{novelid:encodeHash(novelId), folderid:encodeHash(folderInItems.parentFolder)}}"
                class="px-3 py-5 mr-2"
                color="secondary"
                elevation="0"
                small
                tile
              >
                上のフォルダに移動
              </v-btn>

              <v-menu
                v-model="sortDialog"
                :close-on-content-click="false"
                :nudge-width="200"
                offset-y
                rounded="0"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="px-3 py-5 mr-2"
                    color="secondary"
                    elevation="0"
                    small
                    tile
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-img
                      class="mr-3 "
                      contain
                      height="22px"
                      src="../assets/sort.png"
                      width="22px"
                    />
                    並び替え
                  </v-btn>
                </template>
                <SortTypeSelect
                  :callback="selectSort"
                  :items="sortItems"
                  :sort-type="sortType"
                />
              </v-menu>

              <v-btn
                class="px-3  py-5 mr-4"
                color="secondary"
                elevation="0"
                small
                tile
                @click="filterMenu = true"
              >
                <div style="position: relative;">
                  <v-icon size="30">
                    mdi-menu
                  </v-icon>
                  <v-img
                    width="16px"
                    src="../assets/settei.png"
                    style="position: absolute;right:-8px;top:-3px;"
                  />
                </div>
              </v-btn>
            </v-layout>
            <v-list-item>
              <v-spacer />
              <div>
                <v-btn
                  class="text-button-small ma-0 pa-0 pr-3 ml-auto"
                  text
                  small
                  :to="{name: 'TextImport', query: folderInItems.parentFolder ? {folderid: $route.params.folderid} : null}"
                >
                  <ListIcon
                    :style="`color: ${accentColor};width:6px;height:7px`"
                    class="mr-1"
                  />
                  txtファイルから<b>インポート</b>
                </v-btn>
              </div>
              <v-btn
                class="text-button-small ma-0 pa-0 pr-3 ml-auto"
                text
                small
                @click="textAllDownload"
              >
                <ListIcon
                  :style="`color: ${accentColor};width:6px;height:7px`"
                  class="mr-1"
                />
                txtファイルを<b>一括ダウンロード</b>
              </v-btn>
            </v-list-item>
          </v-col>

          <v-col
            v-if="folderInItems.loaded && folderInItems.items && folderInItems.items.length==0"
            class="mb-5 px-3 mt-2"
            cols="12"
          >
            <v-card
              class="mx-auto px-0 px-sm-8"
              flat
              height="580"
              style="padding-top:30px;background-color: var(--v-background2-base);"
              width="440"
            >
              <v-img src="../assets/empty2.png" />
              <v-btn
                color="secondary"
                elevation="0"
                height="60"
                max-height="60"
                style="margin-top:20px;border-radius: 8px;font-size: 17px;font-weight: bold"
                width="100%"
                @click.prevent="showFolderEditDialog(null)"
              >
                <v-img
                  class="mr-3"
                  contain
                  max-height="22px"
                  max-width="22px"
                  src="../assets/folder_w.png"
                />
                フォルダを追加する
                <v-spacer />
                <v-img
                  contain
                  max-height="22px"
                  max-width="22px"
                  src="../assets/plus_w.png"
                />
              </v-btn>
              <v-btn
                :to="{name:'TextEdit', params:{novelid:$route.params.novelid, text_id:'create'},
                      query:$route.params.folderid ? {folderid:$route.params.folderid}:{}}"
                color="secondary"
                elevation="0"
                height="60"
                max-height="60"
                style="margin-top:10px;border-radius: 8px;font-size: 17px;font-weight: bold"
                width="100%"
              >
                <v-img
                  class="mr-3"
                  contain
                  max-height="22px"
                  max-width="22px"
                  src="../assets/file_w.png"
                />
                　本文を追加する
                <v-spacer />
                <v-img
                  contain
                  max-height="22px"
                  max-width="22px"
                  src="../assets/plus_w.png"
                />
              </v-btn>
              <v-btn
                :to="{name: 'TextImport', query: folderInItems.parentFolder ? {folderid: $route.params.folderid} : null}"
                color="secondary"
                elevation="0"
                height="60"
                max-height="60"
                style="margin-top:10px;border-radius: 8px;font-size: 17px;font-weight: bold"
                width="100%"
              >
                <v-img
                  class="mr-3"
                  contain
                  max-height="22px"
                  max-width="22px"
                  src="../assets/file_w.png"
                />
                　
                <div style="font-size: 16px;">
                  　txtファイルからインポート
                </div>
                <v-spacer />
                <v-img
                  contain
                  max-height="22px"
                  max-width="22px"
                  src="../assets/plus_w.png"
                />
              </v-btn>
            </v-card>
          </v-col>

          <v-col
            v-if="folderInItems.items && folderInItems.items.length>0"
            class="pb-4 px-3"
            cols="12"
            lg="6"
            md="6"
            sm="6"
            xl="4"
          >
            <v-btn
              color="secondary"
              elevation="0"
              height="60"
              max-height="60"
              style="border-radius: 8px;font-size: 17px;font-weight: bold"
              width="100%"
              @click.prevent="showFolderEditDialog(null)"
            >
              <v-img
                class="mr-3"
                contain
                max-height="22px"
                max-width="22px"
                src="../assets/folder_w.png"
              />
              フォルダを追加する
              <v-spacer />
              <v-img
                contain
                max-height="22px"
                max-width="22px"
                src="../assets/plus_w.png"
              />
            </v-btn>
          </v-col>
          <v-col
            v-if="folderInItems && folderInItems.items && folderInItems.items.length>0"
            class="pb-4 px-3"
            cols="12"
            lg="6"
            md="6"
            sm="6"
            xl="4"
          >
            <v-btn
              :to="{name:'TextEdit', params:{novelid:$route.params.novelid, text_id:'create'},
                    query:$route.params.folderid ? {folderid:$route.params.folderid}:{}}"
              color="secondary"
              elevation="0"
              height="60"
              max-height="60"
              style="border-radius: 8px;font-size: 17px;font-weight: bold"
              width="100%"
            >
              <v-img
                class="mr-3"
                contain
                max-height="22px"
                max-width="22px"
                src="../assets/file_w.png"
              />
              　本文を追加する
              <v-spacer />
              <v-img
                contain
                max-height="22px"
                max-width="22px"
                src="../assets/plus_w.png"
              />
            </v-btn>
          </v-col>

          <v-col
            cols="0"
            lg="0"
            md="0"
            sm="0"
            xl="4"
          />
          <v-col
            cols="12"
            lg="12"
            md="12"
            sm="12"
            xl="12"
            class="ma-0 pa-0"
          >
            <Bubble
              v-if="(sortType==14 || sortType==15) && folderInItems.items && folderInItems.items.length!=0"
              text="ハンドルをドラッグ＆ドロップで並び替えができます"
            />
          </v-col>

          <draggable
            v-model="folderInItems.items"
            class="row"
            :options="{handle: '.item-handle'}"
          >
            <v-col
              v-for="(item, index) in folderInItems.items"
              :key="'novel_' + index"
              class="pb-4 px-3"
              cols="12"
              lg="6"
              md="6"
              sm="6"
              xl="4"
            >
              <FolderCard
                v-if="item.itemType==0"
                :accent-color="accentColor"
                :background-color="backgroundColor"
                :change-folder-item-parent="changeFolderItem"
                :checked-items="checkedItems"
                :delete-item="showDeleteDialog"
                :edit="showFolderEditDialog"
                :folders="folders"
                :item="item"
                :toggle-item-check="toggleItemCheck"
                :original-sort="sortType==14 || sortType==15"
              />
              <PageCard
                v-if="item.itemType==1"
                :original-sort="sortType==14 || sortType==15"
                :accent-color="accentColor"
                :background-color="backgroundColor"
                :change-folder-item-parent="changeFolderItem"
                :checked-items="checkedItems"
                :delete-item="showDeleteDialog"
                :folders="folders"
                :item="item"
                :novel="novel"
                :toggle-item-check="toggleItemCheck"
              />
            </v-col>
          </draggable>
        </v-row>
      </v-container>
      <AdPc />
    </div>

    <v-dialog
      v-model="folderEditDialog"
      max-width="790"
    >
      <v-card class="mx-auto">
        <v-card-title>
          {{ editItem != null && editItem.id ? "フォルダ編集" : "新しいフォルダの追加" }}
        </v-card-title>

        <v-col>
          <v-text-field
            v-model="editText"
            filled
          />
        </v-col>

        <v-card-actions>
          <v-list-item class="grow">
            <v-row
              align="center"
              justify="end"
            >
              <v-btn
                text
                @click="folderEditDialog=false"
              >
                キャンセル
              </v-btn>

              <v-btn
                text
                @click="saveEditFolder"
              >
                保存
              </v-btn>
            </v-row>
          </v-list-item>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          削除確認
        </v-card-title>
        <v-card-text>指定のアイテムを削除してもよろしいですか？</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="deleteDialog = false"
          >
            キャンセル
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="deleteItem(deleteItemData)"
          >
            削除
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="multiFolderSelectDialog"
      max-width="790"
      scrollable
    >
      <SelectFolder
        :change-folder-item="changeFolderItem"
        :current-folder-id="$route.params.folderid ?$route.params.folderid:-1 "
        :folders="folders"
        :items="checkedItems"
      />
    </v-dialog>

    <v-dialog
      v-model="filterMenu"
      max-width="400"
    >
      <v-card>
        <v-card-title>一覧表示設定</v-card-title>
        <v-card-text>
          <div>
            <ListIcon
              :style="`color: ${accentColor};width:6px;height:7px`"
              class="mr-1"
            />
            表示フィルタリング
          </div>
          <v-chip
            class="ma-1"
            :color="filterSettingUser.pageFilterTitle ? accentColor:null"
            @click="filterSettingUser.pageFilterTitle = !filterSettingUser.pageFilterTitle"
          >
            タイトル
          </v-chip>
          <v-chip
            class="ma-1"
            :color="filterSettingUser.pageFilterDetail ? accentColor:null"
            @click="filterSettingUser.pageFilterDetail = !filterSettingUser.pageFilterDetail"
          >
            本文冒頭
          </v-chip>
          <v-chip
            class="ma-1"
            :color="filterSettingUser.pageFilterUpdate ? accentColor:null"
            @click="filterSettingUser.pageFilterUpdate = !filterSettingUser.pageFilterUpdate"
          >
            更新日
          </v-chip>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="filterMenu = false"
          >
            キャンセル
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="saveFilterSetting"
          >
            保存
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import AdSmp from '../component/AdSmp.vue';
import AdPc from '../component/AdPc.vue';
import {mapState} from "vuex";
import clonedeep from 'lodash.clonedeep';
import PageCard from "@/component/PageCard";
import FolderCard from "@/component/FolderCard";
import axios from "axios";
import config from "@/const";
import firebase from "firebase/app";
import SortTypeSelect from "@/component/SortTypeSelect";
import SelectFolder from "@/component/SelectFolder";
import JSZip from "jszip";
import saveAs from 'file-saver';
import ListIcon from "@/component/svg/ListIcon";
import dayjs from 'dayjs';
import sortByText from '../component/sortByText'
import Bubble from "@/component/Bubble";
import draggable from "vuedraggable";
export default {
  name: "NovelIndex",
  components: {
    SortTypeSelect,
    AdSmp,
    AdPc,
    PageCard,
    FolderCard,
    SelectFolder,
    ListIcon,
    draggable,
    Bubble
  },

  data() {
    return {
      drawer: null,
      accentColor: null,
      backgroundColor: null,
      folderInItems: {
        items: [],
        loaded: false
      },
      baseFolderInItems:null,
      folderEditDialog: false,
      editText: null,
      editItem: null,
      deleteDialog: false,
      deleteItemData: null,
      sortDialog: null,
      sortItems: config.PAGE_SORT_TYPE,
      novel: this.$store.state.NovelListModule.NovelList.find(item => item.id == config.HASH_IDS.decode(this.$route.params.novelid)[0]),
      folders: [],
      checkedItems: [],
      multiFolderSelectDialog: false,
      multiDeleteDialog: false,
      novelId: config.HASH_IDS.decode(this.$route.params.novelid)[0],
      currentNovel: null,
      currentNovelSiteTypeString: null,
      links: [],
      filterMenu:false,
      filterSettingUser: {},
      initialize:false
    }
  },
  computed: {
    ...mapState({
      sortType: state => state.userModule.user.novelListSort,
      user: state => state.userModule.user,
    }),
  },
  watch: {
    $route: {
      handler: function () {
        this.novelId = config.HASH_IDS.decode(this.$route.params.novelid)[0]

        this.currentNovel = this.$store.state.NovelListModule.NovelList.find(element => element.id == this.novelId)
        if (this.currentNovel) {
          this.currentNovelSiteTypeString = config.siteTypeString(this.currentNovel.targetSite)
        }
        this.checkedItems = []
        this.reloadItems()
      }, immediate: true
    },
    sortType: {
      handler: function () {
        this.sort(this.folderInItems)
        this.baseFolderInItems = clonedeep(this.folderInItems);
      }, immediate: false
    },
    folderInItems: {
      handler: async function (val, oldVal) {
          if ((this.sortType==14  || this.sortType==15) && this.hasDiff()) {
            console.dir(val)
            const user = firebase.auth().currentUser;
            const token = await user.getIdToken(false);
            axios.post(config.API_URL + "auth/updateOrder", val, {
              headers: {"X-Firebase-Auth": token},
            }).then(
                value => {
                 this.baseFolderInItems=clonedeep(val);
                }
            ).catch(reason => {
              alert("データ更新に失敗しました。再度お試しください")
            })
          }
      },
      deep: true
    },
    user:{
      handler:function (){
        this.filterSettingUser=clonedeep(this.user);
        console.log("userHandler",this.filterSettingUser)
      },immediate: true
    },
  },

  mounted() {
    this.accentColor = this.$vuetify.theme.themes.light.secondary
    this.backgroundColor = this.$vuetify.theme.dark ? 'black' :
        'white'
  },
  methods: {
    saveFilterSetting(){
      this.$store.commit("userModule/setUser",this.filterSettingUser)
      this.$store.dispatch("userModule/saveSetting")
      this.filterMenu=false
    },
    hasDiff() {
      if(!this.initialize){
        return false
      }
      let changed=false;
      console.log("hasDiff start");
      console.dir(this.baseFolderInItems);
      console.dir(this.folderInItems);
      for (let index = 0; index < this.baseFolderInItems.items.length; index++) {
        console.dir(index, this.folderInItems.items[index])
        this.folderInItems.items[index].item.orderindex=index;
        if (this.baseFolderInItems.items[index].item.id != this.folderInItems.items[index].item.id ||
            this.baseFolderInItems.items[index].itemType != this.folderInItems.items[index].itemType
        ) {
          changed=true;
        }
      }
      console.log("hasDiff changed="+changed);
      return changed;
    },
    encodeHash: function (id) {
      return config.HASH_IDS.encode(id)
    },
    async textAllDownload() {
      const name = dayjs().format('YYYY_MM_DD_HH_mm_ss');
      const zip = new JSZip();
      const folder = zip.folder(name);
      for (let i = 0; i < this.folderInItems.items.length; i++) {
        const value = this.folderInItems.items[i];
        if (value.itemType === 1) {
          const user = firebase.auth().currentUser;
          const token = await user.getIdToken(false);
          const ret = await axios.get(config.API_URL + "auth/page", {
            headers: {"X-Firebase-Auth": token},
            params: {
              "id": value.item.id
            },
            data: {}
          });
          folder.file(`${i + 1}_${ret.data.name}.txt`, ret.data.content);
        }
      }
      const data = await folder.generateAsync({type: 'blob'});
      saveAs(data, `${name}.zip`);
    },
    removeItems() {
      this.multiDeleteDialog = true;
      this.deleteDialog = true;
    },
    toggleItemCheck(item) {
      if (this.checkedItems.indexOf(item) != -1) {
        this.checkedItems.splice(this.checkedItems.indexOf(item), 1)
      } else {
        this.checkedItems.push(item)
      }
    },
    selectSort(sort) {
      this.$store.dispatch("userModule/updateParams", {"novelListSort": sort})
      this.$store.dispatch("userModule/saveSetting")
      this.sortDialog = false
    },
    showDeleteDialog(item) {
      this.deleteItemData = item;
      this.multiDeleteDialog = false;
      this.deleteDialog = true;
    },
    showFolderEditDialog(item = null) {
      this.editItem = item == null ? {
        name: "",
        novelId: config.HASH_IDS.decode(this.$route.params.novelid)[0],
        createdDate: Date.now(),
        folderId: this.$route.params.folderid == undefined ? -1 : config.HASH_IDS.decode(this.$route.params.folderid)[0]
      } : item
      this.editText = item == null ? "" : item.name
      this.folderEditDialog = true
    },
    deleteItem(item) {
      let deleteItems = []
      if (this.multiDeleteDialog) {
        deleteItems = this.checkedItems
      } else {
        deleteItems.push(item)
      }
      deleteItems.forEach(async item => {
        if (item.itemType == 0) {
          const user = firebase.auth().currentUser
          item.item.modifiedTimestamp = Date.now()
          const token = await user.getIdToken(false)
          if (token == null) {
            return
          }
          item.item.updateDate = Date.now()
          item.item.modifiedTimestamp = Date.now()
          axios.delete(config.API_URL + "auth/folder/" + item.item.id, {
            headers: {"X-Firebase-Auth": token},
            data: {}
          }).then(
              value => {
                this.reloadItems()
                this.deleteDialog = false;
              }
          ).catch(reason => {
            alert("削除中にエラーが発生しました")
          });
        } else if (item.itemType == 1) {
          const user = firebase.auth().currentUser
          item.item.modifiedTimestamp = Date.now()
          const token = await user.getIdToken(false)
          if (token == null) {
            return
          }
          axios.delete(config.API_URL + "auth/page/" + item.item.id, {
            headers: {"X-Firebase-Auth": token},
            data: {}
          }).then(
              value => {
                this.reloadItems()
                this.deleteDialog = false;
              }
          ).catch(reason => {
            alert("削除中にエラーが発生しました")
          });
        }
      })
    },
    async saveEditFolder() {

      let newData = clonedeep(this.editItem)
      newData.name = this.editText
      const user = firebase.auth().currentUser
      const token = await user.getIdToken(false)
      if (token == null) {
        return
      }
      newData.updateDate = Date.now()
      if (newData.createdDate == undefined) {
        newData.createdDate = Date.now()
      }
      newData.modifiedTimestamp = Date.now()
      axios.post(config.API_URL + "auth/folder", newData, {
        headers: {"X-Firebase-Auth": token, "fromWeb": true},
      }).then(
          value => {
            this.reloadItems()
            this.folderEditDialog = false
          }
      ).catch(reason => {
        alert("データ更新に失敗しました。再度お試しください")
      })
    },
    async reloadItems() {
      const user = firebase.auth().currentUser
      const token = await user.getIdToken(false)
      if (token == null) {
        return
      }
      this.initialize=false
      this.novelId = config.HASH_IDS.decode(this.$route.params.novelid)[0]
      let ret = await axios.get(config.API_URL + "auth/folderitems", {
        headers: {"X-Firebase-Auth": token},
        params: {
          "novelId": config.HASH_IDS.decode(this.$route.params.novelid)[0],
          "folderId": this.$route.params.folderid == undefined ? -1 : config.HASH_IDS.decode(this.$route.params.folderid)[0]
        },
        data: {}
      })

      let folderInItems = ret.data
      console.log("folderInItems ret=",folderInItems)
      if (folderInItems.links.length) {
        this.links = [
          {
            text: '本文一覧',
            disabled: false,
            exact:true,
            to: `/novels/${this.$route.params.novelid}/`
          }
        ];

        for (let i = 0; i < folderInItems.links.length; i++) {
          const value = folderInItems.links[i];
          this.links.push({
            text: value.title,
            exact:true,
            disabled: i === folderInItems.links.length - 1,
            to: `/novels/${this.$route.params.novelid}/folders/${config.HASH_IDS.encode(value.id)}/`
          });
        }
      } else {
        this.links = [];
      }

      folderInItems = this.sort(folderInItems)
      this.baseFolderInItems = clonedeep(folderInItems);
      let folderRet = await axios.get(config.API_URL + "auth/folders", {
        headers: {"X-Firebase-Auth": token},
        params: {
          "novelId": config.HASH_IDS.decode(this.$route.params.novelid)[0]
        },
        data: {}
      })
      this.folders = [{id: "-1", name: "最上位（フォルダ選択なし）", nestIndex: 0}]
      this.insertFolderItem(folderRet.data, -1, 1)

      this.folderInItems = {
        items: [],
        loaded: true
      }
      const list = this.folderInItems
      list.links = folderInItems.links
      list.items = []
      list.parentFolder = folderInItems.parentFolder
      list.parentName = folderInItems.parentName
      const vm = this;
      const ite = function* () {
        // NOTE: 1アイテムづつsetTimeoutでレンダリング
        for (let len = folderInItems.items.length, i = 0; i < len; i++) {
          yield setTimeout(() => {
            const item = folderInItems.items[i]; // Get items one by one
            list.items.push(item);

           ite.next();
            if(len == i+1){
              vm.initialize = true
            }
          });
        }
      }();
      ite.next();



    },
    sort(folderInItems) {
      folderInItems.items.sort((a, b) => {
        switch (this.sortType) {
          case 0:
            return sortByText.sortNum(b.item.updateDate, a.item.updateDate)
          case 1:
            return sortByText.sortNum(a.item.updateDate, b.item.updateDate)
          case 2:
            return sortByText.sortNum(b.item.createdDate, a.item.createdDate)
          case 3:
            return sortByText.sortNum(a.item.createdDate, b.item.createdDate)
          case 4: {
            if (b.itemType == 0 && a.itemType == 1) {
              return 1
            } else if (b.itemType == 1 && a.itemType == 0) {
              return -1
            }
            return sortByText.sortNum(b.item.updateDate, a.item.updateDate)
          }
          case 5: {
            if (b.itemType == 0 && a.itemType == 1) {
              return 1
            } else if (b.itemType == 1 && a.itemType == 0) {
              return -1
            }
            return sortByText.sortNum(a.item.updateDate, b.item.updateDate)
          }
          case 6: {
            if (b.itemType == 0 && a.itemType == 1) {
              return 1
            } else if (b.itemType == 1 && a.itemType == 0) {
              return -1
            }
            return sortByText.sortNum(b.item.createdDate, a.item.createdDate)
          }
          case 7: {
            if (b.itemType == 0 && a.itemType == 1) {
              return 1
            } else if (b.itemType == 1 && a.itemType == 0) {
              return -1
            }
            return sortByText.sortNum(a.item.createdDate, b.item.createdDate)
          }
          case 8: {
            if (b.itemType == 0 && a.itemType == 1) {
              return -1
            } else if (b.itemType == 1 && a.itemType == 0) {
              return 1
            }
            return sortByText.sortNum(b.item.updateDate, a.item.updateDate)
          }
          case 9: {
            if (b.itemType == 0 && a.itemType == 1) {
              return -1
            } else if (b.itemType == 1 && a.itemType == 0) {
              return 1
            }
            return sortByText.sortNum(a.item.updateDate, b.item.updateDate)
          }
          case 10: {
            if (b.itemType == 0 && a.itemType == 1) {
              return -1
            } else if (b.itemType == 1 && a.itemType == 0) {
              return 1
            }
            return sortByText.sortNum(b.item.createdDate, a.item.createdDate)
          }
          case 11: {
            if (b.itemType == 0 && a.itemType == 1) {
              return -1
            } else if (b.itemType == 1 && a.itemType == 0) {
              return 1
            }
            return sortByText.sortNum(a.item.createdDate, b.item.createdDate)
          }
          case 12: {
            if (sortByText.sort(a.item.name, b.item.name) != 0) {
              return sortByText.sort(a.item.name, b.item.name) * -1
            }
            return sortByText.sortNum(b.item.createdDate, a.item.createdDate)
          }
          case 13: {
            if (sortByText.sort(a.item.name, b.item.name) != 0) {
              return sortByText.sort(a.item.name, b.item.name)
            }
            return sortByText.sortNum(a.item.createdDate, b.item.createdDate)
          }
          case 14: {
            return a.item.orderindex - b.item.orderindex;
          }
          case 15: {
            return a.item.orderindex - b.item.orderindex;
          }
        }
        return 0
      })
      return folderInItems
    },
    insertFolderItem(parent, parentid, nestIndex) {
      parent.forEach(item => {
        if (item.folderId == parentid) {
          item.nestIndex = nestIndex
          this.folders.push(item)
          this.insertFolderItem(parent, item.id, nestIndex + 1)
        }
      })
    },
    async changeFolderItem(toFolderId, items) {
      if (toFolderId == null) {
        this.multiFolderSelectDialog = false
        return
      }
      const user = firebase.auth().currentUser
      const token = await user.getIdToken(false)
      if (token == null) {
        return
      }
      await Promise.all(items.map(async item => {
        item.item.folderId = toFolderId
        if (item.itemType == 1) {
          await axios.post(config.API_URL + "auth/pageChangeFolder", item.item, {
            headers: {"X-Firebase-Auth": token},
          })
        } else {
          await axios.post(config.API_URL + "auth/folder", item.item, {
            headers: {"X-Firebase-Auth": token},
          })
        }
      }))
      this.multiFolderSelectDialog = false
      this.reloadItems()
    },
    openSearch() {
      this.$store.dispatch("SearchResultModule/clear")
      this.$router.push({name: 'SearchPage', params: {novelid: this.encodeHash(this.novelId)}})
    }
  },
}
</script>

<style scoped>
.griditem-border {
  background-color: var(--v-bordercolor-base) !important;
  min-height: 2px;
}

.griditem-content-bold {
  font-size: 12px;
  font-weight: bold;
  color: var(--v-textcolor-base) !important;
}

.griditem-content {
  font-size: 12px;
  color: var(--v-textcolor-base) !important;
}

.text-button-small {
  font-size: 11px;
  color: var(--v-textcolor-base) !important;
}

.flex-container {
  display: flex;
  justify-content: flex-start;
}

.flex-container > :first-child {
  margin-right: auto;
}
</style>
